import {useContext, useState} from "react";
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import config from "config";
import MESSAGE from "components/message";
import api from "services/api";
import DIALOGWAIT from "dialog/dialogwait";
import RADIO from "components/radio";
import {Buffer} from 'buffer';
import CAMERACOMPONENT from "components/cameraimagem";
import {CidadeContext} from "services/cidade";

const { v4: uuidv4 } = require('uuid');

function AdminNotificacao() {
    const [titulo, setTitulo] = useState('');
    const [corpo, setCorpo] = useState('');
    const [imagem, setImagem] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);
    const [tipoenvio, setTipoEnvio] = useState('N');
    const [todos, setTodos] = useState('I');

    const navigate = useNavigate();

    const {cod_cidade} = useContext(CidadeContext)

    async function enviaMensagem() {

        // Limitar tamanho da imagem antes de enviar
        const dadosBase = {
            "type": "M",
            "title": titulo,
            "body": corpo,
            "image": `${config.BASEIMG}${imagem}`,
            "cod_cidade": cod_cidade,
        };

        setLoading(true);

        try {
            // Primeiro POST para notificação
            const postResponse = await api.post(`${config.NOTIFICACAO}?p=${tipoenvio}`, dadosBase);

            if (postResponse.status === 202) {
                try {
                    // GET para obter tokens de registro
                    const getResponse = await api.get(`${config.PUSHNOTIFICATION}/registration?TODOS=${todos}&cod_cidade=${cod_cidade}`);

                    if (getResponse.status === 200) {
                        const registrationTokens = getResponse.data;
                        const username = config.BASICAPI;
                        const password = config.BASICAPI;
                        const token = Buffer.from(`${username}:${password}`).toString('base64');
                        const headers = {
                            'Authorization': `Basic ${token}`,
                            'Content-Type': 'application/json'
                        };

                        // Função para dividir em lotes de 500 e garantir JSON < 10MB
                        function splitTokens(tokens, maxPerBatch = 500, maxJsonSize = 10 * 1024 * 1024) {
                            let batches = [];
                            let currentBatch = [];
                            for (let i = 0; i < tokens.length; i++) {
                                currentBatch.push(tokens[i]);
                                // Estimar tamanho do JSON
                                const tempDados = { ...dadosBase, registrationTokens: currentBatch };
                                const tempSize = Buffer.byteLength(JSON.stringify(tempDados), 'utf8');
                                if (currentBatch.length >= maxPerBatch || tempSize > maxJsonSize) {
                                    // Remove último token se excedeu tamanho
                                    if (tempSize > maxJsonSize) {
                                        currentBatch.pop();
                                    }
                                    batches.push([...currentBatch]);
                                    currentBatch = [];
                                }
                            }
                            if (currentBatch.length > 0) {
                                batches.push(currentBatch);
                            }
                            return batches;
                        }

                        const batches = splitTokens(registrationTokens);
                        let allFailedTokens = [];
                        for (let batch of batches) {
                            const dados = { ...dadosBase, registrationTokens: batch };
                            try {
                                const sendPushResponse = await axios.post(`https://horse.opnet.com.br${config.SENDPUSH}`, dados, { headers });
                                if (sendPushResponse.data.failedTokens !== null && Array.isArray(sendPushResponse.data.failedTokens)) {
                                    allFailedTokens = allFailedTokens.concat(sendPushResponse.data.failedTokens);
                                }
                            } catch (sendPushError) {
                                console.error('Erro ao enviar push notification para lote:', sendPushError);
                                setMensagem('Erro ao enviar push notification para um dos lotes.');
                            }
                        }

                        // PATCH para lidar com tokens falhos
                        if (allFailedTokens.length > 0) {
                            const patchDados = { 'failedTokens': allFailedTokens };
                            try {
                                await api.patch(`${config.PUSHNOTIFICATION}/registration`, patchDados);
                            } catch (patchError) {
                                console.error('Erro no PATCH:', patchError);
                            }
                        }

                        setLoading(false);
                        navigate('/');
                    } else {
                        throw new Error('Falha ao obter tokens de registro');
                    }
                } catch (getError) {
                    console.error('Erro no GET:', getError);
                    setMensagem('Erro ao buscar tokens de registro.');
                    setLoading(false);
                }
            } else {
                throw new Error(postResponse.response.data.erro || 'Erro desconhecido no POST inicial');
            }
        } catch (postError) {
            console.error('Erro no POST inicial:', postError);
            setMensagem(postError.message || 'Erro ao enviar a notificação.');
            setLoading(false);
        }
    }


    return (
        <div>
            <h2 className="section-title">Envio de Notificações</h2>
            <MESSAGE msg={mensagem} />
            
            <div className="row justify-content-center">
                <div className="col-12 col-xl-10">
                    <div className="bg-card-admin rounded-4 p-4 p-md-5">
                        <form>
                            <div className="row g-4">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="forTitulo" className="form-label fw-bold text-muted">Título da Notificação</label>
                                        <input type="text"
                                            value={titulo}
                                            onChange={(e) => setTitulo(e.target.value)}
                                            className="form-control form-control-lg rounded-3 border-2" 
                                            id="forTitulo" 
                                            placeholder="Ex: Nova promoção disponível!"
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="forCorpo" className="form-label fw-bold text-muted">Mensagem</label>
                                        <textarea 
                                            maxLength={2000}
                                            value={corpo}
                                            onChange={(e) => setCorpo(e.target.value)}
                                            className="form-control rounded-3 border-2" 
                                            id="forCorpo" 
                                            rows="4"
                                            placeholder="Digite o conteúdo da mensagem..."
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <label className="form-label fw-bold text-muted">Imagem da Notificação</label>
                                    <div className="notification-image-upload-container border-2 border-dashed rounded-4 p-4 text-center bg-light">
                                        <CAMERACOMPONENT
                                            heigth={200}
                                            width={200}
                                            foto={imagem}
                                            setFoto={setImagem}
                                            className={'foto-notificacao mx-auto rounded-3 shadow-sm'}
                                            base64={false}
                                            nomedoarquivo={`not${ uuidv4() }.png`}
                                            diretorio={'imgban'}
                                        />
                                        <div className="mt-3 small text-muted">
                                            {imagem ? `Arquivo: ${imagem}` : 'Nenhuma imagem selecionada'}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="d-flex flex-column gap-4">
                                        <div className="form-group p-3 bg-light rounded-4 border">
                                            <label className="form-label fw-bold text-muted mb-3 d-block">Público Alvo (Sistema)</label>
                                            <RADIO
                                                chave={'forTEnvio'}
                                                avalores={['N', 'P', 'I']}
                                                alabel={['Todos', 'Parceiros', 'Teste']}
                                                setValor={setTipoEnvio}
                                                valor={tipoenvio}
                                            />
                                        </div>
                                        
                                        <div className="form-group p-3 bg-light rounded-4 border">
                                            <label className="form-label fw-bold text-muted mb-3 d-block">Destinatários Push</label>
                                            <RADIO
                                                chave={'forTODOS'}
                                                avalores={['A', 'P', 'I']}
                                                alabel={['Todos', 'Parceiros', 'Teste']}
                                                setValor={setTodos}
                                                valor={todos}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mt-4">
                                    <button 
                                        type="button" 
                                        className="btn btn-primary btn-lg w-100 py-3 shadow-sm d-flex align-items-center justify-content-center gap-2" 
                                        onClick={() => enviaMensagem()}
                                        style={{ borderRadius: '14px' }}
                                    >
                                        <i className="fas fa-paper-plane"></i>
                                        <span>Disparar Notificação</span>
                                    </button>
                                    <p className="text-center text-muted small mt-3 mb-0">
                                        <i className="fas fa-info-circle me-1"></i>
                                        O envio pode levar alguns minutos dependendo da quantidade de usuários.
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <DIALOGWAIT
                trigger={loading}
                setTrigger={setLoading}
            />
        </div>
    );
}

export default AdminNotificacao;